// Rileva automaticamente l'URL dell'API in base all'ambiente
// In produzione: usa URL relativo (stesso dominio)
// In sviluppo: usa URL relativo (il proxy in package.json gestisce il routing)
const getApiUrl = () => {
  // Usa sempre URL relativo - il proxy (in sviluppo) o il server (in produzione)
  // gestirà il routing alle API
  return '';
};

const rawApiUrl = getApiUrl();

// Rimuovi lo slash finale se presente per evitare doppi slash
export const API_URL = rawApiUrl.replace(/\/+$/, '');
export default API_URL;

